// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BbCGz","footer":"styles_footer__3krnL","passCodeTooltip":"styles_passCodeTooltip__2qZ8N"};